import { Img } from "ui-kit/components-branded/index"

export function OnlineOrOfflineLabel({ online }: { online: boolean }) {
    return (
        <span data-testid="online-or-offline">
            {online ? (
                <>
                    <Img src="person-with-laptop-emoji.png" className="booking__emoji" />
                    Онлайн
                </>
            ) : (
                <>
                    <Img src="/person-emoji.png" className="booking__emoji" />
                    Лично
                </>
            )}
        </span>
    )
}
